import Owner from '../shared/owners/owner';
import Team, { GuillotineTeam } from '../shared/teams/team';

export function getNames(members: Owner[], teams: Team[]): Team[] | GuillotineTeam[] {
  for (let i = 0; i < teams.length; i++) {
    const owner: Owner | undefined = members.find(
      (member: Owner) => member.id === teams[i].owners[0]
    );

    if (owner) {
      teams[i].owner = owner;
    }
  }

  return teams;
}